import { render } from "./ThanksContact.vue?vue&type=template&id=4afa2d0f&scoped=true"
import script from "./ThanksContact.vue?vue&type=script&lang=js"
export * from "./ThanksContact.vue?vue&type=script&lang=js"

import "./ThanksContact.vue?vue&type=style&index=0&id=4afa2d0f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4afa2d0f"

export default script